import { Navigate, Outlet } from "react-router-dom";
import { getRequest } from "../../config/axiosConfig";
import { useEffect, useState } from "react";
import Loader from "../loader/loader";

export const ProtectPatientRoute = () => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const checkPatientAuth = async () => {
      try {
        const res = await getRequest({
          url: process.env.REACT_APP_BASE_URL + "auth/patient/me-patient",
        });

        if (res?.success) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.log(error);
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    checkPatientAuth();
  }, []);

  useEffect(() => {
    console.log("isAuthenticated", isAuthenticated);
  }, [isAuthenticated]);

  if (loading) return <Loader />;

  if (!isAuthenticated) {
    return <Navigate to="/patient-login" replace />;
  }

  return <Outlet />;
};
